import React from "react";
import { execQuery } from "../api";
import { DataTable, DataTableData } from "./DataTable";
import { useMethod } from "@roc-digital/ui-lib";

interface SqlDataTableProps {
  label: string;
  subtext: string;
  children: string;
  width?: number;
  height?: number;
  onClick?(data: any, event: any);
  extraColumns?: {field: string, label: string}[];
  formatData?: (data: any[]) => any[];
  noDefaultColumn?: boolean;
}

export function SqlDataTable(props: SqlDataTableProps) {
  const getData = React.useCallback(async () => {
    if(!props.children) return [];

    let data = await execQuery<DataTableData>({
      args: [],
      sql: props.children
    });

    if(props.formatData) data = props.formatData(data);

    return data;
  }, [props.children]);

  const query = useMethod(getData, {
    autoRun: []
  });
  
  return <DataTable
    data={query.result}
    loading={query.loading}
    label={props.label}
    subtext={props.subtext}
    onExport={props.onClick}
    extraColumns={props.extraColumns}
    noDefaultColumn={props.noDefaultColumn}
  />
}